import { getPlatformType, getPlatformUrl } from "@/utils/ql_platform";

export function useImgUrl(imgUrl: any) {
	if (!imgUrl) return "数据错误";
	const ql_platform_type = getPlatformType();
	if (imgUrl.includes("https://")) {
		return imgUrl;
	} else if (ql_platform_type) {
		const uri = getPlatformUrl(ql_platform_type)?.uri;
		return (uri || import.meta.env.VITE_IMG_URL) + imgUrl;
	} else {
		return `${import.meta.env.VITE_IMG_URL}${imgUrl}`;
	}
}

export function useThemeImgUrl(imgUrl: any) {
	const themeCode = "default";
	return `/image/${themeCode}/${imgUrl}`;
}
